module.exports = __webpack_public_path__ + "img/SES_130410001.e2d65fbb.jpg";